import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { LanguageProvider } from './contexts/LanguageContext';
import Header from './components/Header';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';

import Home from './pages/Home';
import Vehicles from './pages/Vehicles';
import VehicleDetail from './pages/VehicleDetail';
import Reservation from './pages/Reservation';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminVehicles from './pages/admin/AdminVehicles';
import AdminReservations from './pages/admin/AdminReservations';
import PrivateRoute from './components/PrivateRoute';

import './App.css';

function App() {
  return (
    <LanguageProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={
              <>
                <Header />
                <main className="main-content">
                  <Home />
                </main>
                <Footer />
                <WhatsAppButton />
              </>
            } />
            <Route path="/vehicles" element={
              <>
                <Header />
                <main className="main-content">
                  <Vehicles />
                </main>
                <Footer />
                <WhatsAppButton />
              </>
            } />
            <Route path="/vehicles/:id" element={
              <>
                <Header />
                <main className="main-content">
                  <VehicleDetail />
                </main>
                <Footer />
                <WhatsAppButton />
              </>
            } />
            <Route path="/reservation" element={
              <>
                <Header />
                <main className="main-content">
                  <Reservation />
                </main>
                <Footer />
                <WhatsAppButton />
              </>
            } />

            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={
              <PrivateRoute>
                <AdminDashboard />
              </PrivateRoute>
            } />
            <Route path="/admin/vehicles" element={
              <PrivateRoute>
                <AdminVehicles />
              </PrivateRoute>
            } />
            <Route path="/admin/reservations" element={
              <PrivateRoute>
                <AdminReservations />
              </PrivateRoute>
            } />
          </Routes>
          <ToastContainer 
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;
